import axios from 'axios';

const portalApi = axios.create({
  baseURL: `${process.env.VUE_APP_API_URL_PORTAL_C3}/api`,
});

export default portalApi;
